import { request } from "@/plugins/axios";
import qs from 'qs';

// 登录接口
export async function login(params) {
    return await request({
        url: '/api/u_l/login',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 注册接口
export async function register(params) {
    return await request({
        url: '/api/u_l/charge',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 注册页百度转化回调接口
export async function baiduconversion(params) {
    return await request({
        url: '/api/u_l/baiduconversion',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 获取用户信息

export async function getInfo() {
    return await request({
        url: '/api/u_i/userInfo',
        method: 'post'
    })
}

// web列表信息
export async function getWebList() {
    return await request({
        url: '/api/u_is/orderList',
        method: 'post'
    })
}

// 重置密码获取code (不验证账户是否存在)
export async function getAccountCode(params) {
    return await request({
        url: '/api/u_m/account_code',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 注册获取code (验证账户是否存在)
export async function getregistercode(params) {
    return await request({
        url: '/api/u_m/verif',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 重置密码

export async function reset(params) {
    return await request({
        url: '/api/u_r/reset',
        method: 'post',
        data:qs.stringify(params)
    })
}

// 未注册用户下单成功后，发邮件提醒
export async function sendEmail(params) {
    return await request({
        url: '/api/u_m/volun',
        method: 'get',
        params:params
    })
}
// 注册二维码
export async function service(params) {
    return await request({
        url: '/api/u_h/customer',
        method: 'get',
        params:params
    })
}
// 用户协议
export async function getYHTreaty(params) {
    return await request({
        url: '/api/a_t/treaty',
        method: 'post',
        data:params
    })
}

// 定位国家

export async function location_country(params) {
    return await request({
        url: '/api/com/location_country',
        method: 'get',
        params:params
    })
}